/* Version: 3.5.149 */
'use client';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import brandingColors from '../colors/colors.js';
import { BUTTON_VARIANT } from '../components/Button/constants.js';
import { MOBILE_MENU_VARIANT, TAB_VARIANT, LANG_VARIANT, SIGN_IN_VARIANT } from '../components/SideNav/constants.js';
import '../components/Toggle/index.js';
import { TAB_ALIGNMENT } from '../components/UtilityHeader/constants.js';
import { GRID_BREAKPOINTS_CONNECTED } from '../spacing/index.js';
import { typography } from '../typography/typography.js';
import { rem } from '../utils/functions.js';
import { TOGGLE_VARIANT } from '../components/Toggle/constants.js';

var tertiaryButton = {
  bg: "var(--mux-color-neutral-light-white, ".concat(brandingColors.white, ")"),
  bgActive: "var(--mux-color-accent-dark-2, ".concat(brandingColors.dark_2_coral, ")"),
  bgHover: "var(--mux-color-accent-dark-1, ".concat(brandingColors.dark_1_coral, ")"),
  bgDisabled: "var(--mux-color-neutral-light-default, ".concat(brandingColors.light_grey, ")"),
  border: "var(--mux-color-neutral-light-white, ".concat(brandingColors.white, ")"),
  borderActive: "var(--mux-color-neutral-light-white, ".concat(brandingColors.white, ")"),
  borderHover: "var(--mux-color-neutral-light-white, ".concat(brandingColors.white, ")"),
  color: "var(--mux-color-neutral-dark-default, ".concat(brandingColors.dark_navy, ")"),
  colorActive: "var(--mux-color-neutral-light-white, ".concat(brandingColors.white, ")"),
  colorDisabled: brandingColors.light_3_dark_navy,
  colorHover: "var(--mux-color-neutral-light-white, ".concat(brandingColors.white, ")"),
  fontSize: typography.fontSize,
  fontWeight: typography.fontWeightNormal,
  iconColor: "var(--mux-color-accent-default, ".concat(brandingColors.coral, ")"),
  iconActive: "var(--mux-color-neutral-light-white, ".concat(brandingColors.white, ")"),
  iconHover: "var(--mux-color-neutral-light-white, ".concat(brandingColors.white, ")")
};
var globalTheme = {
  name: 'globalTheme',
  colorPalette: {
    primaryColors: {
      main: {
        shade_light_4: brandingColors.light_4_green,
        shade_light_3: brandingColors.light_3_green,
        shade_light_2: brandingColors.light_2_green,
        shade_light_1: brandingColors.light_1_green,
        shade_default: brandingColors.m_green,
        shade_link: brandingColors.dark_navy,
        shade_dark_1: brandingColors.dark_1_green,
        shade_dark_2: brandingColors.dark_2_green,
        shade_dark_3: brandingColors.dark_3_green
      },
      alternate: {
        shade_light_4: brandingColors.light_4_blue,
        shade_light_3: brandingColors.light_3_blue,
        shade_light_2: brandingColors.light_2_blue,
        shade_light_1: brandingColors.light_1_blue,
        shade_default: brandingColors.blue,
        shade_dark_1: brandingColors.dark_1_blue,
        shade_dark_2: brandingColors.dark_2_blue,
        shade_dark_3: brandingColors.dark_3_blue
      }
    },
    neutralColors: {
      dark: {
        shade_light_4: brandingColors.light_4_dark_navy,
        shade_light_3: brandingColors.light_3_dark_navy,
        shade_light_2: brandingColors.light_2_dark_navy,
        shade_light_1: brandingColors.light_1_dark_navy,
        shade_default: brandingColors.dark_navy,
        shade_dark_1: brandingColors.super_dark_navy
      },
      light: {
        shade_white: brandingColors.white,
        shade_light_2: brandingColors.light_2_grey,
        shade_light_1: brandingColors.light_1_grey,
        shade_default: brandingColors.light_grey,
        shade_dark_1: brandingColors.dark_1_light_grey,
        shade_dark_2: brandingColors.dark_2_light_grey,
        shade_dark_3: brandingColors.dark_3_light_grey
      }
    },
    accentColor: {
      shade_light_4: brandingColors.light_4_coral,
      shade_light_3: brandingColors.light_3_coral,
      shade_light_2: brandingColors.light_2_coral,
      shade_light_1: brandingColors.light_1_coral,
      shade_default: brandingColors.coral,
      shade_dark_1: brandingColors.dark_1_coral,
      shade_dark_2: brandingColors.dark_2_coral,
      shade_dark_3: brandingColors.dark_3_coral
    },
    secondaryColors: {
      one: {
        shade_light_4: brandingColors.light_4_violet,
        shade_light_3: brandingColors.light_3_violet,
        shade_light_2: brandingColors.light_2_violet,
        shade_light_1: brandingColors.light_1_violet,
        shade_default: brandingColors.violet,
        shade_dark_1: brandingColors.dark_1_violet,
        shade_dark_2: brandingColors.dark_2_violet,
        shade_dark_3: brandingColors.dark_3_violet
      },
      two: {
        shade_light_4: brandingColors.light_4_gold,
        shade_light_3: brandingColors.light_3_gold,
        shade_light_2: brandingColors.light_2_gold,
        shade_light_1: brandingColors.light_1_gold,
        shade_default: brandingColors.gold,
        shade_dark_1: brandingColors.dark_1_gold,
        shade_dark_2: brandingColors.dark_2_gold,
        shade_dark_3: brandingColors.dark_3_gold
      },
      three: {
        shade_light_4: brandingColors.light_4_turquoise,
        shade_light_3: brandingColors.light_3_turquoise,
        shade_light_2: brandingColors.light_2_turquoise,
        shade_light_1: brandingColors.light_1_turquoise,
        shade_default: brandingColors.turquoise,
        shade_dark_1: brandingColors.dark_1_turquoise,
        shade_dark_2: brandingColors.dark_2_turquoise,
        shade_dark_3: brandingColors.dark_3_turquoise
      }
    },
    utilityColors: {
      error: brandingColors.red_error,
      alert: brandingColors.red_error,
      warning: brandingColors.utility_warning,
      info: brandingColors.utility_info,
      complete: brandingColors.utility_success,
      link: brandingColors.dark_navy
    }
  },
  button: {
    bgActive: "var(--mux-color-accent-dark-2, ".concat(brandingColors.dark_2_coral, ")"),
    bgHover: "var(--mux-color-accent-dark-1, ".concat(brandingColors.dark_1_coral, ")"),
    bgDisabled: "var(--mux-color-neutral-light-default, ".concat(brandingColors.light_grey, ")"),
    colorActive: "var(--mux-color-neutral-light-white, ".concat(brandingColors.white, ")"),
    colorHover: "var(--mux-color-neutral-light-white, ".concat(brandingColors.white, ")"),
    colorDisabled: "var(--mux-color-neutral-dark-light-3, ".concat(brandingColors.light_3_dark_navy, ")"),
    fontSize: rem(19),
    lineHeight: rem(24),
    minWidth: '150px',
    padding: "".concat(rem(16), " ").concat(rem(32)),
    variant: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BUTTON_VARIANT.PRIMARY, {
      bg: "var(--mux-color-accent-default, ".concat(brandingColors.coral, ")"),
      border: "var(--mux-color-accent-default, ".concat(brandingColors.coral, ")"),
      color: "var(--mux-color-neutral-light-white, ".concat(brandingColors.white, ")"),
      fontWeight: typography.fontWeightBold
    }), BUTTON_VARIANT.SECONDARY, {
      border: "var(--mux-color-accent-default, ".concat(brandingColors.coral, ")"),
      bg: "var(--mux-color-neutral-light-white, ".concat(brandingColors.white, ")"),
      color: "var(--mux-color-neutral-dark-default, ".concat(brandingColors.dark_navy, ")"),
      fontWeight: typography.fontWeightDemibold
    }), BUTTON_VARIANT.TERTIARY, tertiaryButton), BUTTON_VARIANT.TERTIARY_BACK, tertiaryButton), BUTTON_VARIANT.TERTIARY_NOICON, tertiaryButton)
  },
  checkbox: {
    bgDisabled: "var(--mux-color-neutral-light-default, ".concat(brandingColors.light_grey, ")"),
    borderDisabled: "var(--mux-color-neutral-light-default, ".concat(brandingColors.light_grey, ")"),
    iconDisabled: "var(--mux-color-neutral-dark-light-3, ".concat(brandingColors.light_3_dark_navy, ")")
  },
  dropdown: {
    native: false
  },
  errors: {
    showIcon: true,
    showInputBackground: true
  },
  footer: {
    logo: {
      height: '20px',
      maxWidth: '100%'
    }
  },
  layout: {
    cds: true
  },
  quickActionNotification: {
    fontSize: rem(14),
    lineHeight: rem(20),
    showDefaultIcon: false,
    // NOTE: This format is intended to map 1:1 with our useMedia hook
    media: {
      queries: ["(max-width: ".concat(GRID_BREAKPOINTS_CONNECTED.MOBILE, "px)")],
      values: [{
        offsetBottom: '16px',
        offsetHorizontal: '16px',
        maxWidth: 'none',
        fullWidth: true
      }],
      defaultValue: {
        offsetBottom: '32px',
        offsetHorizontal: '32px',
        maxWidth: '320px',
        fullWidth: false
      }
    },
    colors: {
      default: brandingColors.dark_navy,
      error: brandingColors.dark_2_coral,
      success: brandingColors.dark_1_green
    }
  },
  select: {
    listItem: {
      fontWeight: typography.fontWeightNormal,
      hover: {
        bg: brandingColors.light_2_grey
      },
      selected: {
        bg: brandingColors.light_4_green,
        fontWeight: typography.fontWeightNormal,
        hover: brandingColors.light_4_green,
        showLeftBorder: false
      }
    }
  },
  sideNav: {
    brandLogo: {
      showLogo: true,
      height: '100px',
      width: '100px'
    },
    wordmarkLogo: {
      height: '20px',
      maxWidth: '100%'
    },
    mainNav: {
      top: '0px',
      backgroundColor: brandingColors.light_1_dark_navy,
      fontSize: rem(13),
      lineHeight: 'normal',
      iconOpacity: 0.4
    },
    subNav: {
      item: {
        height: '80px',
        padding: '40px',
        selected: {
          backgroundColor: brandingColors.light_2_grey,
          borderColor: brandingColors.m_green,
          fontWeight: 400
        }
      }
    },
    mobile: {
      variant: MOBILE_MENU_VARIANT.OVERLAY,
      color: brandingColors.dark_navy,
      backgroundColor: brandingColors.light_2_grey,
      toggle: {
        showLabel: false
      },
      item: {
        backgroundColor: brandingColors.white,
        height: '80px'
      },
      wordmarkLogo: {
        height: '20px',
        maxWidth: '100%',
        paddingLeft: '18px',
        paddingRight: '18px'
      },
      header: {
        borderColor: brandingColors.light_grey,
        showTabs: false
      },
      footer: {
        borderColor: brandingColors.light_grey,
        showTabs: true
      },
      tab: {
        variant: TAB_VARIANT.NO_LINE
      },
      lang: {
        variant: LANG_VARIANT.SMALL
      },
      searchField: {
        height: '60px'
      },
      signIn: {
        variant: SIGN_IN_VARIANT.OUTLINE
      }
    }
  },
  textLink: {
    fontWeight: 600,
    textUnderlineOffset: '6px',
    iconColor: "var(--mux-color-accent-default, ".concat(brandingColors.coral, ")"),
    textShadow: 'transparent',
    default: {
      color: "var(--mux-color-neutral-dark-default, ".concat(brandingColors.dark_navy, ")"),
      hover: {
        underlineColor: 'transparent'
      }
    },
    inverse: {
      color: "var(--mux-color-neutral-light-white, ".concat(brandingColors.white, ")"),
      hover: {
        underlineColor: 'transparent'
      }
    }
  },
  toggle: {
    colors: {
      button: brandingColors.white,
      unchecked: brandingColors.light_4_dark_navy,
      uncheckedHovered: brandingColors.light_3_dark_navy,
      checked: brandingColors.m_green,
      checkedHovered: brandingColors.dark_1_green,
      disabled: brandingColors.light_grey,
      trackUnchecked: brandingColors.light_4_dark_navy,
      trackUncheckedHovered: brandingColors.light_3_dark_navy,
      trackChecked: brandingColors.m_green,
      trackCheckedHovered: brandingColors.dark_1_green,
      trackDisabled: brandingColors.light_grey,
      label: brandingColors.dark_navy,
      labelDisabled: brandingColors.dark_navy
    },
    trackHeight: 8,
    buttonTransition: '0.2s ease-in-out',
    variant: _defineProperty(_defineProperty({}, TOGGLE_VARIANT.LARGE, {
      trackWidth: 60,
      diameter: 28
    }), TOGGLE_VARIANT.SMALL, {
      trackWidth: 40,
      diameter: 20
    })
  },
  utilityHeader: {
    showLogo: true,
    height: '80px',
    marginLeft: '0px',
    paddingRight: '28px',
    main: {
      backgroundColor: brandingColors.dark_navy,
      color: brandingColors.white
    },
    sub: {
      backgroundColor: brandingColors.light_2_grey,
      color: brandingColors.dark_navy
    },
    tab: {
      alignment: TAB_ALIGNMENT.RIGHT
    },
    headerButton: {
      height: '44px',
      borderWidth: '0px'
    },
    menu: {
      active: {
        backgroundColor: brandingColors.light_2_grey
      },
      direction: 'bottom left'
    }
  },
  gridConfig: {
    default: {
      columns: 12,
      gutterWidth: 24,
      margin: 64
    },
    breakpoints: [{
      breakpoint: GRID_BREAKPOINTS_CONNECTED.MOBILE,
      columns: 12,
      gutterWidth: 16,
      margin: 16
    }, {
      breakpoint: GRID_BREAKPOINTS_CONNECTED.TABLET,
      columns: 12,
      gutterWidth: 24,
      margin: 40
    }, {
      breakpoint: GRID_BREAKPOINTS_CONNECTED.TABLET_DESKTOP,
      columns: 12,
      gutterWidth: 24,
      margin: 40
    }, {
      breakpoint: GRID_BREAKPOINTS_CONNECTED.DESKTOP,
      columns: 12,
      gutterWidth: 24,
      margin: 40
    }]
  }
};

export { globalTheme as default };
